import React from 'react';
import Avatar from '@atlaskit/avatar';
import { Grid, Text, Flex, Anchor, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

export const IdeaCard = ({
	summary,
	issueKey,
	issueTypeIconUrl,
	issueTypeName,
}: {
	summary: string;
	issueKey: string;
	issueTypeIconUrl?: string;
	issueTypeName?: string;
}) => (
	<Anchor href={`/browse/${issueKey}`} xcss={ideaCardStyles}>
		<Grid templateColumns="20px 1fr" gap="space.100">
			{issueTypeIconUrl ? (
				<Tooltip content={issueTypeName || null}>
					<Flex>
						<Avatar
							appearance="square"
							src={issueTypeIconUrl}
							size="xsmall"
							borderColor="transparent"
						/>
					</Flex>
				</Tooltip>
			) : null}
			<Text maxLines={1}>{summary}</Text>
		</Grid>
	</Anchor>
);

const ideaCardStyles = xcss({
	borderBottom: `1px solid ${token('color.border', '#ebecf0')}`,
	display: 'flex',
	paddingLeft: token('space.100', '8px'),
	height: '40px',
	alignItems: 'center',
	transition: '0.3s',
	cursor: 'pointer',
	color: 'color.text',
	textDecoration: 'none',
	':hover': {
		backgroundColor: 'color.background.neutral.subtle.hovered',
		color: 'color.text',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
	':last-child': {
		border: 'none',
	},
});
